export default __webpack_public_path__ + "static/media/culture_EP15.fd2d2659.png";